import React, { useState } from "react";

import { Translate } from "react-redux-i18n";

const SportDemographicOptions = ({ data, getSport, getPosition }) => {
    const [positions, setPositions] = useState([]);

    data = [{ id: "", name: "select" }, ...data];
    const sportsSelection = data.map((sport, index) => {
        return (
            <option key={index} value={sport.id}>
                {sport.name}
            </option>
        );
    });

    const handleOnChangeSport = (event) => {
        const sportId = event.target.value;
        getSport(sportId);

        console.log(sportId);

        if (sportId === "") {
            return setPositions([]);
        }

        const [sportPositions] = data.filter((object) => {
            return object.id === parseInt(sportId);
        });

        console.log(sportPositions.positions.length);

        if (sportPositions.positions.length > 0) {
            data = sportPositions.positions;

            setPositions(data);
            getPosition(data[0].id);
            return;
        }

        return setPositions([])
    }

    const handleOnChangePosition = (event) => {
        const positionId = event.target.value;
        getPosition(positionId);
    }

    return (
        <div>
            <div className="form-group">
                <p className="est text-left mb-1"><Translate value="sport" />:</p>
                <select className="form-control" onChange={handleOnChangeSport} name="sport">
                    {sportsSelection}
                </select>
            </div>
            {positions.length > 0 && (
                <div className="form-group">
                    <p className="est text-left mb-1"><Translate value="position" />:</p>
                    <select className="form-control" name="position" onChange={handleOnChangePosition}>
                        {
                            positions.map(position => (
                                <option key={position.id} value={position.id}>
                                    {position.name}
                                </option>
                            ))
                        }
                    </select>
                </div>
            )}
        </div>
    );
};

export default SportDemographicOptions;
